import { Mfa_Status, sendAppMfaCode } from '@chegg/one-auth-sdk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleGeneralError } from "./steps/error";
import { handleOnboarding } from "./steps/onboarding";
import { handleSent } from "./steps/sent";
import { factorSelectionSlice } from "../slices/factorSelection";
export { orchestrator };
async function orchestrator(getState, dispatch) {
  try {
    dispatch(factorSelectionSlice.actions.setMfaByAppButtonLoader(true));
    var _getState$authParams = getState().authParams,
      cheggMfaToken = _getState$authParams.cheggMfaToken,
      uuid = _getState$authParams.uuid;
    var response = await sendAppMfaCode(cheggMfaToken, uuid);
    dispatch(factorSelectionSlice.actions.setMfaByAppButtonLoader(false));
    switch (response.status) {
      case Mfa_Status.ONBOARDING:
        await handleOnboarding(getState, dispatch, response);
        break;
      case Mfa_Status.SENT:
        await handleSent(getState, dispatch);
        break;
      case Mfa_Status.BLOCKED:
        handleGeneralError(dispatch, 'blocked');
        break;
      default:
        handleGeneralError(dispatch);
        break;
    }
  } catch (e) {
    handleGeneralError(dispatch);
    dispatch(factorSelectionSlice.actions.setMfaByAppButtonLoader(false));
  }
}
export var startOrchestrator = createAsyncThunk('orchestrator', async function (_, _ref) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  return orchestrator(getState, dispatch);
});